import { useEffect, useState } from "react";
import { CustomButton } from "../../../shared/CustomButton";
import { Add } from "@mui/icons-material";
import CustomModal from "../../../shared/CustomModal";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getFn, postFn, putFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import SearchAndSelect from "../../../shared/SearchAndSelect";
import { toast } from "react-toastify";

const properties = [
  "Size",
  "Capacity",
  "Display Size",
  "Storage",
  "Weight",
  "Dimension",
  "Power Consumption",
];

const AddProductVariantType = ({ editVariantType, setEditVariantType }) => {
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [selectCategory, setSelectCategory] = useState();
  const client = useQueryClient();

  const handleClose = () => {
    setEditVariantType();
    setNewTitle("");
    setSelectCategory();
    setOpen(false);
  };

  const { data: categories } = useQuery(
    ["categories"],
    () => getFn({}, API_URLS.category),
    {
      select: (data) =>
        data?.data?.data.map(({ category, id }) => ({
          label: category,
          value: id,
        })),
    }
  );

  const args = [
    {
      variant_id: editVariantType?.id || undefined,
      category: selectCategory,
      title: properties[newTitle],
    },
    API_URLS.storageTypeApi,
  ];

  const { mutate: mutation } = useMutation(
    () => (editVariantType ? putFn(...args) : postFn(...args)),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          client.invalidateQueries("typeTwoCategories");
          handleClose();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleSubmit = () => {
    console.log(selectCategory, properties[newTitle], "ccccc");
    if (selectCategory && properties[newTitle]) {
      mutation();
    } else {
      toast.warn("Please fill all the details");
    }
  };

  useEffect(() => {
    if (editVariantType) {
      setOpen(true);
      const { title, category } = editVariantType;
      setSelectCategory(category);
      setNewTitle(properties.findIndex((item) => item === title));
    } else {
      setNewTitle(properties[newTitle]);
    }
  }, [editVariantType]);
  console.log("aaaaaaa", properties[newTitle]);
  return (
    <div>
      <CustomButton
        className="border border-black"
        onClick={() => setOpen(true)}
      >
        <Add /> Add Type Two
      </CustomButton>
      <CustomModal
        className="w-1/3"
        open={open}
        onClose={handleClose}
        title={`${editVariantType ? "Update" : "Add"}  Type Two`}
      >
        <div className="flex flex-col gap-4">
          <SearchAndSelect
            label="Category"
            value={selectCategory}
            setValue={setSelectCategory}
            options={categories}
          />
          <SearchAndSelect
            label="Title"
            value={newTitle}
            setValue={(value) => setNewTitle(value)}
            options={properties.map((item, idx) => ({
              label: item,
              value: idx,
            }))}
          />
          <CustomButton
            className="mx-0 ml-auto border border-black w-28"
            variant="outlined"
            onClick={handleSubmit}
          >
            {editVariantType ? "Update" : "Add"}
          </CustomButton>
        </div>
      </CustomModal>
    </div>
  );
};

export default AddProductVariantType;
